import React, { useEffect, useState } from 'react';
import { useT } from '@/contexts/I18nContext';

// Never more than 20 branch cards per page on the «Все филиалы» boards —
// the whole-network / system-worker case must not render 40+ live cards at
// once (Alexey, 2026-07-19 follow-up). «Показать ещё» reveals the next page.
export const ZONES_PAGE_SIZE = 20;

export function usePagedZones<T>(items: T[] | undefined, resetKey?: unknown) {
  const [visibleCount, setVisibleCount] = useState(ZONES_PAGE_SIZE);

  // Reset paging when the dataset changes shape (refresh, zoom/date switch).
  useEffect(() => {
    setVisibleCount(ZONES_PAGE_SIZE);
  }, [items?.length, resetKey]);

  const list = items ?? [];
  return {
    visible: list.slice(0, visibleCount),
    remaining: Math.max(0, list.length - visibleCount),
    showMore: () => setVisibleCount(v => Math.min(v + ZONES_PAGE_SIZE, list.length)),
  };
}

export function ShowMoreZonesButton({ remaining, onClick }: { remaining: number; onClick: () => void }) {
  const { t } = useT();
  if (remaining <= 0) return null;
  return (
    <div className="flex justify-center">
      <button
        type="button"
        onClick={onClick}
        className="rounded-md border border-border px-4 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
      >
        {t('portfolio.showMore', { n: Math.min(remaining, ZONES_PAGE_SIZE) })}
      </button>
    </div>
  );
}
